import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Redirect } from 'react-router-dom';
import { PrivateRoutes } from "../../../pages/shared/models/routes";

interface IProps {
    tyc?: boolean
}
interface IState {
    loading: boolean
}
const sleep = (milliseconds: any) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

const   ToHomeFromAdelantar = (props:IProps) => {
    
    const[loading, setloading]=useState(true)
        
   
    function onHide() {
       
    }

    const redirect= async () => {
        await sleep(5000)
        setloading(false)  
    }

    useEffect(() => {
        redirect()
    }, [])

    
        if (loading) {
            if ( props.tyc){
                return (
                    <Dialog header="Términos y Condiciones" visible={true} style={{ width: '30vw' }} onHide={()=>onHide()} >
                        <div >
                            Para continuar debe aceptar los terminos y condiciones, será redireccionado a la pantalla de Home
                        </div >
                    </Dialog>
                )}
            else
                return (
                <Dialog header="Adelanto Express" visible={true} style={{ width: '30vw' }} onHide={()=>onHide()} >
                    <div >
                        Se ha procesado la solicitud con éxito!
                    </div >
                </Dialog>
            )
        }
        else {
            return <Redirect to={PrivateRoutes.HOME} />
        }
    }
export default ToHomeFromAdelantar